//
//
//
//
//
//
//
//

export default {
  layout: 'error',
  props: ['error'] // you can set a custom layout for the error page
}
